const screenToggleAction = {
  type: "Increase",
};

export default screenToggleAction;
